import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AppErrorBoundary } from '@core/components/AppErrorBoundary';
import './styles/tokens.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/ui.css';
// テーマ(D-132)。既存の CSS を上書きするので最後に読む
import './styles/themes.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root が見つかりません');

// 非同期の処理で受け止められなかったエラーは、画面を止めずに記録だけ残す(2026-10-05)。
// 画面の描画中のエラーは AppErrorBoundary / 各画面の errorElement が案内を出す
window.addEventListener('unhandledrejection', (e) => {
  console.error('[cc-system] 処理されなかったエラー', e.reason);
});

createRoot(root).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
);
